"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var useRecaptchaReset = function () {
    React.useEffect(function () {
        return function () {
            setTimeout(function () {
                $('.grecaptcha-badge')
                    .filter(function (index, element) {
                    return $(element).closest('.recaptcha-mounted').length === 0;
                })
                    .remove();
            });
        };
    }, []);
};
exports.default = useRecaptchaReset;
